import React, { useState, useMemo } from 'react';

const variableRegex = /({{\w+}})/g;

const parseStyleString = (styleStr) => {
  const styleObj = {};
  if (!styleStr) return styleObj;

  styleStr.split(';').forEach((declaration) => {
    const [property, value] = declaration.split(':');
    if (property && value) {
      const camelCaseProperty = property
        .trim()
        .replace(/-(\w)/g, (_, char) => char.toUpperCase());
      styleObj[camelCaseProperty] = value.trim();
    }
  });
  return styleObj;
};

const MessagePreview = ({ html }) => {
  const htmlStr = String(html || '');
  const [inputs, setInputs] = useState({});

  const variables = useMemo(() => {
    const found = htmlStr.match(variableRegex);
    return found ? Array.from(new Set(found)) : [];
  }, [htmlStr]);

  const handleInputChange = (variable, value) => {
    setInputs((prev) => ({ ...prev, [variable]: value }));
  };

  if (!htmlStr) {
    return <span style={{ color: '#bbb' }}>Nada para exibir...</span>;
  }

  const processNode = (node, keyPrefix = '') => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      const parts = text.split(variableRegex);
      return parts.map((part, idx) => {
        if (variables.includes(part)) {
          const variable = part;
          return (
            <input
              key={keyPrefix + variable + idx}
              value={inputs[variable] ?? ''}
              onChange={(e) => handleInputChange(variable, e.target.value)}
              placeholder={variable.replace(/[{|}]/g, '')}
              disabled={true}
              style={{
                background: '#e6f7ff',
                color: '#1890ff',
                borderRadius: 4,
                padding: '1px 6px',
                margin: '0 2px',
                fontWeight: 500,
                border: '1px solid #b3d8ff',
                fontSize: 13,
                outline: 'none',
                minWidth: 60,
                textAlign: 'center',
                boxSizing: 'border-box'
              }}
              spellCheck={false}
              autoComplete="off"
            />
          );
        }
        return part ? (
          <React.Fragment key={keyPrefix + idx}>{part}</React.Fragment>
        ) : null;
      });
    }
    if (node.nodeType === Node.ELEMENT_NODE) {
      const children = Array.from(node.childNodes).map((child, idx) =>
        processNode(child, keyPrefix + idx + '-')
      );
      const Tag = node.tagName.toLowerCase();

      const props = {};
      for (let attr of node.attributes) {
        if (attr.name === 'style') {
          props.style = parseStyleString(attr.value);
        } else if (attr.name === 'class') {
          props.className = attr.value;
        } else {
          props[attr.name] = attr.value;
        }
      }

      return React.createElement(
        Tag,
        { ...props, key: keyPrefix },
        ...children
      );
    }
    return null;
  };

  let parsed;
  try {
    const parser = new window.DOMParser();
    parsed = parser.parseFromString(`<div>${htmlStr}</div>`, 'text/html');
  } catch {
    return (
      <span style={{ color: '#bbb' }}>Erro ao processar visualização</span>
    );
  }
  const root = parsed.body.firstChild;

  return <span style={{ wordBreak: 'break-word' }}>{processNode(root)}</span>;
};

export default MessagePreview;
